import * as sha1 from 'js-sha1'
import constants from '@/constants'

const aux = {
  translation: function (value, locale, language) {
    let aux = value
    try {
      aux = JSON.parse(value)
    } catch (e) {}
    if (aux[locale]) {
      return aux[locale]
    } else if (aux['en']) {
      return aux['en']
    } else {
      const firstKey = Object.keys(aux)[0]
      return aux[firstKey]
    }
  },
  verifyURL: function (url) {
    if (url.indexOf('www') >= 0 || url.indexOf('http') >= 0) return url
    return `${window.location.protocol}//www.${url}`
  }
}

const utils = {
  urlExists(url) {
    try {
      const http = new XMLHttpRequest()
      http.open('HEAD', url, false)
      http.send()
      return http.status != 404
    } catch {
      return false
    }
  },
  getAllLanguages (selectedLanguages) {
    const languages = []
    for (var key in constants.isoLangs) {
      languages.push({
        ID: key,
        Name: constants.isoLangs[key].nativeName.split(', ').join('-')
      })
    }
    if (selectedLanguages) {
      return languages.filter(x => selectedLanguages.indexOf(x.ID) >= 0)
    }
    return languages
  },
  getAllMenuType () {
    const menuType = []
    for (var key in constants.menuType) {
      menuType.push({
        ID: constants.menuType[key],
        Name: key
      })
    }
    return menuType
  },
  isAdmin: function () {
    return localStorage.getItem('role') === sha1('1')
  },
  isSuperuser: function () {
    return localStorage.getItem('role') === sha1('-1')
  },
  isPrivate: function () {
    const host = window.location.host
    const parts = host.split('.')
    const domainLength = 3 // route1.example.com => domain length = 3
    if (parts.length === (domainLength - 1)) {
      return true
    } else if (parts[0] === 'www') {
      if (parts[0] === 'www' && (parts[1] === 'admin' || parts[1] === process.env.VUE_APP_URL)) {
        return true
      }
    } else if (parts[0] === 'admin') {
      return true
    }
    return false
  },
  setActiveEnterprise: function (v_, enterprise, noRedirect) {
    const selectEnterprise = enterprise.length > 0 ? enterprise[0] : enterprise

    localStorage.setItem('enterprise', JSON.stringify(selectEnterprise))
    v_.$store.state.app.image = selectEnterprise.Banner && selectEnterprise.Banner.length > 0 ? aux.verifyURL(selectEnterprise.Banner) : ''
    v_.$store.state.app.enterpriseName = selectEnterprise.Name && selectEnterprise.Name.length > 0 ? selectEnterprise.Name : ''
    v_.$store.state.app.enterpriseID = selectEnterprise.ID && selectEnterprise.ID.length > 0 ? selectEnterprise.ID : ''
    if (!noRedirect) v_.$router.push('/dashboard')
  },
  getActiveEnterprise: function () {
    const enterprise = JSON.parse(localStorage.getItem('enterprise'))
    // console.log(enterprise.Languages)
    try {
      enterprise.Languages = enterprise.Languages.toString().split(',')
    } catch (error) {
      console.error(error)
    }
    // console.log(enterprise.Languages)
    try {
      enterprise.Carousel = enterprise.Carousel ? enterprise.Carousel.toString().split(',') : []
    } catch (error) {
      console.error(error)
    }
    return enterprise
  },
  getActiveUser: function () {
    return JSON.parse(localStorage.getItem('user'))
  },
  getDomain: function () {
    const getHostname = window.location.hostname
    return getHostname.split('.')[0] === 'www' ? getHostname.split('.')[1] : getHostname.split('.')[0]
  },
  getAPIURL: function (path, isPrivate, id) {
    const getHostname = window.location.hostname
    const pathSplit = getHostname.split('.')
    let domain = ''
    if (pathSplit.length > 2) {
      domain = pathSplit[0] === 'www' ? pathSplit[1] : pathSplit[0]
    }
    if (domain === process.env.VUE_APP_API_URL.split('.')[0] || domain === 'admin') domain = ''
    domain = !isPrivate && domain.length === 0 ? id : domain
    const area = isPrivate ? 'private' : 'public'
    let result = `${window.location.protocol}//www.${process.env.VUE_APP_API_URL}/${area}/${path}`
    if (id && isPrivate) result = `${result}/${id}`
    return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`?domain=${domain}`)
  },
  verifyURL: function (url) {
    return aux.verifyURL(url)
  },
  getPublicURL: function (domain) {
    return `${window.location.protocol}//www.${domain}.${process.env.VUE_APP_API_URL}`
  },
  getTranslation: function (value, locale, language) {
    return aux.translation(value, locale, language)
  },
  prepareMenu: function (menus, locale, language, expandPref) {
    const result = []
    menus.forEach(function (element) {
      // if (element.Content) {
      //   element.Content = element.Content
      //   try {
      //     element.Content = JSON.parse(element.Content)
      //   } catch (error) {}
      // }
      element.T_Name = aux.translation(element.Name, locale, language)
      element.submenus = menus.filter(x => x.ParentID === element.ID)
      if (expandPref) {
        if (expandPref.content) {
          element.isExpand = true
        } else if (element.submenus.length > 0 && expandPref.submenu) {
          element.isExpand = true
        } else {
          element.isExpand = false
        }
      }
      result.push(element)
    })
    return result.filter(x => !x.ParentID)
  },
  pad (value, nItem = 2) {
    let aux = ''
    for (let i = 0; i < nItem; i++) aux = aux.concat('0')
    let result = aux.concat(value)
    result = result.substring(result.length - nItem, result.length)
    return result
  },
  checkAvailability: function (availability) {
    if (!availability.IsTemp) return true
    if (availability.IsTemp && (new Date() >= new Date(availability.StartDate) && (new Date() <= new Date(availability.EndDate) || availability.NoEndDate))) {
      return true
    }
    return false
  },
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}

export default utils
